import { useMutation, useQueryClient } from '@tanstack/react-query';

import { useTRPC } from '@/utils/trpc';

export const useDeleteDocumentAssessmentResultsTRPC = () => {
  const trpc = useTRPC();
  const queryClient = useQueryClient();
  const mutation = useMutation({
    ...trpc.frontend.documentAssessmentResult.delete.mutationOptions({
      onSuccess: async () => {
        await queryClient.invalidateQueries({
          queryKey: trpc.frontend.assessment.resultsRegister.queryKey(),
        });
        await queryClient.invalidateQueries({
          queryKey: trpc.frontend.assessment.register.queryKey(),
        });
      },
    }),
  });

  return {
    deleteDocumentAssessmentResults: async (ids: string[]): Promise<void> => {
      await mutation.mutateAsync({ Ids: ids });
    },
    isLoading: mutation.isPending,
  };
};
